<template>
	<side-popup :level="level" title="Connect custom app" @close="$emit('close')" >
		<template v-slot:default>
			<div class="shopify-settings-custom-app">
					<div class="layout-column flex">
						<div>
							<p>
								You can connect your Shopify custom app directly to Funnelish using the custom app credentials.
							</p>
						</div>
						<div class="margin-t-25">
							<input-field  placeholder="eg. yourstore.myshopify.com"
							              label="Your store domain name"
							              @input="storeNameChanged"
							              v-model="config.store_url" />
						</div>

						<div class="margin-t-25">
							<input-field  placeholder=""
							              label="Token"
							              v-model="config.token" />
						</div>

						<div class="margin-t-25">
							<input-field  placeholder=""
							              label="API key"
							              v-model="config.api_key" />
						</div>
						<div class="margin-t-25">
							<input-field  placeholder=""
							              label="API secret key"
							              v-model="config.api_secret_key" />
						</div>
					</div>

			</div>
		</template>
		<template v-slot:actions>
			<v-button label="Save changes" :loading="connecting" @click="connectToService()" />
			<v-button label="Close" border @click="$emit('close')" />
		</template>
	</side-popup>
</template>

<script>
import InputField from "@/components/base/input-field";
import VSwitch from "@/components/base/v-switch";
import ConnectService from "@/components/popup-details-parts/connect-service";
import VButton from "@/components/base/v-button";
import API from "@/api";
import DetailsPopup from "@/components/base/details-popup";
import SidePopup from "@/components/base/side-popup";
export default {
	name: "shopify-settings-custom-app",
	components: {SidePopup, DetailsPopup, VButton, ConnectService, VSwitch, InputField},
	mixins: [API],
	props:['level','config','attributes','configData','isShopifyRedirect','redirectShopName'],
	data() {
		return {
			connecting: false,
			isLocal: false,
		}
	},
	computed:{
	},
	methods: {
		storeNameChanged(v) {
			v = v.replace("https://", "").replace("/", "")
			this.config.store_url = v;
		},
		async connectToService() {
			try {
				this.connecting = true;

				this.config.is_custom = true;
				let r = await this.api.integrations.customConnect(this.attributes.name, {
					arg1: this.config.store_url,
					arg2: JSON.stringify(this.config),
				})
				if (!r || r.error) {
					this.$error(r, r.error)
					return
				}
				console.log(r)
				this.$emit('done', r.result)
			} catch (e) {
				this.$error(e, e.data)
			} finally {
				this.connecting = false;
			}
		},
	},
	mounted() {
		this.isLocal = window.location.hostname==='localhost';
	}
}
</script>

<style lang="scss" scoped>
.shopify-settings-custom-app {
	p {
		padding: 0;
		line-height: 1.5;
	}
	.or-wrapper {
		height: 35px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-bottom: 10px;
		margin-top: 10px;
		h2 {
			font-size: 16px;
			margin-bottom: 0;
			background-color: #f7f9fd;
			padding: 0 1rem;
			position: absolute;
			text-transform: uppercase;
		}
		.line {
			width: 100%;
			height: 1px;
			background-color: #e6e8ea;
		}
	}
}
</style>
